export default __webpack_public_path__ + "static/media/portfolio-unraf-2.3ff051df.jpg";